const ProductCardSkeleton = () => (
  <div className="min-w-0 shrink-0 grow-0 basis-[75%] pl-[1px] md:basis-[40%] lg:basis-1/4 xl:basis-1/5">
    <div className="aspect-portrait animate-pulse bg-gray-100" />
    <div className="px-4 pt-3 pb-5">
      <div className="h-4 w-1/4 animate-pulse bg-gray-100" />
      <div className="h-5 animate-pulse bg-gray-100" />
      <div className="mt-2 h-5 w-2/5 animate-pulse bg-gray-100" />
      <div className="mt-2 h-4 w-1/4 animate-pulse bg-gray-100" />
    </div>
  </div>
);

ProductCardSkeleton.displayName = "ProductCardSkeleton";

export default ProductCardSkeleton;
